import VSelectCustomer from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCustomer', VSelectCustomer),
};
